import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { NavButtons } from '../NavButtons/NavButtons';
import { MergeLoyaltySummary } from './MergeLoyaltySummary';
import EmailService from '../../../../services/EmailService';
import { EmailStore } from '../../../../state/EmailStore';
import TopicTracker from '../../../../tracking/TopicTracker';

export const MergeLoyaltySummaryContainer = ({
  onConfirmButtonClick,
  onError
}) => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    TopicTracker.show('email', 'summary');
  }, []);

  const handleConfirmButtonClick = () => {
    setIsLoading(true);

    TopicTracker.click('email', 'summary-ok');

    EmailService.merge(EmailStore.getMergeableEmail(), EmailStore.getLoyaltyMergeStatus())
      .then(() => {
        setIsLoading(false);
        onConfirmButtonClick();
      })
      .catch((error) => {
        setIsLoading(false);
        onError(error.message);
      });
  };

  const handleCancelClickButton = () => {
    TopicTracker.click('email', 'summary-cancel');
  };

  return (
    <Fragment>
      <MergeLoyaltySummary/>
      <NavButtons
        isLoading={isLoading}
        isDisabled={false}
        isCancelEnabled
        onClick={handleConfirmButtonClick}
        onClickCancel={handleCancelClickButton}
      />
    </Fragment>);
};

MergeLoyaltySummaryContainer.propTypes = {
  onConfirmButtonClick: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
};
